import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconShieldLockLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.02 15.827h3.96a.876.876 0 0 0 .645-.26.875.875 0 0 0 .26-.644V11.96a.875.875 0 0 0-.26-.644.875.875 0 0 0-.644-.26h-.087v-1c0-.524-.183-.969-.549-1.335a1.818 1.818 0 0 0-1.336-.55c-.524 0-.969.184-1.335.55a1.818 1.818 0 0 0-.549 1.336v1h-.106a.875.875 0 0 0-.644.26.875.875 0 0 0-.26.643v2.962c0 .256.087.47.26.644.173.173.388.26.644.26Zm.99-4.77v-1c0-.283.095-.52.287-.712a.968.968 0 0 1 .712-.287.97.97 0 0 1 .713.287c.192.192.287.43.287.713v1h-2ZM12 21.372a1.855 1.855 0 0 1-.596-.1c-2.11-.75-3.787-2.08-5.034-3.99-1.247-1.909-1.87-3.97-1.87-6.181V6.596c0-.38.11-.722.328-1.026.218-.303.5-.524.847-.66l5.692-2.125c.214-.077.425-.116.633-.116.208 0 .419.039.633.116l5.692 2.125c.347.136.629.357.847.66.219.304.328.646.328 1.026V11.1c0 2.211-.623 4.272-1.87 6.182-1.247 1.91-2.925 3.239-5.034 3.989a1.854 1.854 0 0 1-.596.1Zm0-1.471c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.586a.298.298 0 0 0-.053-.173.318.318 0 0 0-.149-.115l-5.692-2.125a.282.282 0 0 0-.106-.02.282.282 0 0 0-.106.02L6.202 6.298a.318.318 0 0 0-.149.115.298.298 0 0 0-.053.173V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconShieldLockLine;
